/**
 * Returns is SSA run or no
 * @returns {boolean}
 */
export const isSSA = (): boolean => {
  try {
    const url: URL = new URL(window.location.href);
    return !!url.searchParams.get('ssa');
  } catch (error) {
    return false;
  }
};
